var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('messages-list',{staticClass:"pb-1 pr-1",attrs:{"messages":_vm.globalMessages},on:{"message:remove":_vm.handleMessageRemove}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }